// extracted by mini-css-extract-plugin
export default {"content":"Investment_content__lGzZG","heading":"Investment_heading__BufdV","img":"Investment_img__DYNhT","fee":"Investment_fee__Fko-O","callback":"Investment_callback__+0apR"};